module.exports = __webpack_public_path__ + "img/blancing.d6e16bd.svg";